if (typeof window.serverBus === "undefined") {
    window.serverBus = new Vue();
}
const serverBus = window.serverBus

export {
    serverBus
}